import { motion } from "framer-motion";

const FALLBACK = [
  { name: "The Azure Residences", location: "Patia", progress: 62, phase: "Structural work — L18" },
  { name: "KLiving Plaza", location: "Kalinga Nagar", progress: 41, phase: "Podium + core" },
  { name: "The Meridian Exchange", location: "Chandrasekharpur", progress: 12, phase: "Excavation" },
];

function Row({ p, i }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ duration: 0.8, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
      className="grid grid-cols-12 gap-4 md:gap-8 items-center py-8 border-b border-editorial/15"
    >
      <div className="col-span-12 md:col-span-1 chapter-num text-editorial/50">
        {String(i + 1).padStart(2, "0")}
      </div>
      <div className="col-span-12 md:col-span-4">
        <h4 className="font-serif-display text-2xl md:text-3xl text-editorial">{p.name}</h4>
        <p className="chapter-num text-editorial/60 mt-1">{p.location?.toUpperCase()}</p>
      </div>
      <div className="col-span-8 md:col-span-4">
        <div className="chapter-num text-editorial/50 mb-2">{p.phase}</div>
        <div className="relative h-[3px] bg-editorial/15 overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: `${p.progress}%` }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ duration: 1.6, delay: 0.3 + i * 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="absolute inset-y-0 left-0 bg-lime_kl"
          />
        </div>
      </div>
      <div className="col-span-4 md:col-span-3 text-right">
        <motion.span
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          transition={{ delay: 0.4 + i * 0.15, duration: 0.6 }}
          className="font-serif-display text-4xl md:text-6xl text-editorial tabular-nums"
        >
          {String(p.progress).padStart(2, "0")}<span className="text-lime_kl">%</span>
        </motion.span>
      </div>
    </motion.div>
  );
}

export default function LiveProgress({ projects }) {
  // Fix: Explicitly ensure we have a valid array before executing filter logic
  const validProjects = Array.isArray(projects) ? projects : [];
  
  const data = validProjects
    .filter((p) => p && (p.status === "ongoing" || p.status === "upcoming"))
    .slice(0, 5);
    
  const rows = data.length 
    ? data.map((p) => ({
        name: p.name,
        location: p.location?.split(",")[0] || p.location,
        progress: p.progress ?? 0,
        phase: p.typology || "In progress",
      })) 
    : FALLBACK;

  return (
    <section id="progress" className="relative bg-emerald_kl text-editorial py-28 md:py-36 px-6 md:px-10 grain overflow-hidden">
      <div className="max-w-[1400px] mx-auto relative">
        <div className="grid grid-cols-12 gap-6 items-end mb-16 md:mb-20">
          <div className="col-span-12 md:col-span-8">
            <div className="chapter-num text-lime_kl mb-6">
              <span className="inline-block w-8 h-px bg-lime_kl/60 align-middle mr-3" />
              LIVE FROM SITE · WEEK {Math.ceil(((new Date() - new Date(new Date().getFullYear(), 0, 1)) / 86400000 + 1) / 7)}
            </div>
            <h2 className="font-serif-display text-5xl md:text-7xl lg:text-[96px] leading-[0.95] tracking-tight text-editorial">
              Progress, <span className="italic text-lime_kl">not promises.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4 md:text-right">
            <p className="text-editorial/70 max-w-sm md:ml-auto">
              A public log of every active build. Updated on the first Monday of each month, in the same numbers we share with our board.
            </p>
          </div>
        </div>

        <div className="border-t border-editorial/15">
          {rows.map((p, i) => (
            <Row key={p.name || i} p={p} i={i} />
          ))}
        </div>

        <div className="mt-12 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-editorial/60 chapter-num">
          <span>SOURCE — INTERNAL PROJECT DASHBOARD · AUDITED QUARTERLY</span>
          <span>LAST SYNC — {new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }).toUpperCase()}</span>
        </div>
      </div>
    </section>
  );
}